import Backbone from 'backbone'
import template from './text-link-badges-test.hbs'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import nonAbbreviatedValuesTooltip from 'scoreboard/components/non-abbreviated-values-tooltip.hbs'

var TextLinkBadgesView = Backbone.View.extend({

	className: 'admin table-hack display-layout admin-test-view admin-test-text-link-badges',

	events: {
		'mouseenter .equation-viewer .equation .reference': 'highlightEquationReference',
		'mouseenter .equation-viewer .values .reference': 'highlightReverseEquationReference',
		'mouseleave .equation-viewer .reference': 'removeEquationReferenceHighlight'
	},

	render: function () {
		this.$el.empty().append(template())

		// Set up tooltip and details examples
		// The relevant dom elements need to be in the DOM before creating TooltipAndDetails
		process.nextTick(() => {
			this.defaultTooltip = new TooltipAndDetails({
				el: this.el,
				selector: '.tooltip-example-1',
				tooltipContent: e => {
					return nonAbbreviatedValuesTooltip({
						header: e.target.dataset.unshortenedHeader,
						value: e.target.dataset.unshortenedValue
					})
				},
				details: e => {
					console.log('CLICKED A TOOLTIP DETAIL BUTTON')
				}
			})

			this.promiseTooltip = new TooltipAndDetails({
				el: this.el,
				selector: '.tooltip-example-2',
				tooltipContent: e => {
					return new Promise(resolve => {
						// Simulate a slight delay before the content is given to the TooltipAndDetails
						setTimeout(() => {
							resolve(nonAbbreviatedValuesTooltip({
								header: e.target.dataset.unshortenedHeader,
								value: e.target.dataset.unshortenedValue
							}))
						}, 500)
					})
				},
				details: e => {
					console.log('CLICKED A TOOLTIP DETAIL BUTTON')
				}
			})

			this.promiseTooltip = new TooltipAndDetails({
				el: this.el,
				selector: '.tooltip-example-3',
				tooltipContent: e => {
					return new Promise((resolve, reject) => {
						// Simulate a slight delay before the reject is thrown
						setTimeout(() => {
							reject('ERROR: Tooltip promise failed!')
						}, 500)
					})
				},
				details: e => {
					console.log('CLICKED A TOOLTIP DETAIL BUTTON')
				}
			})
		})

		return this
	},

	_highlightReference: function(reference, id) {
		reference.addClass('text-link-emphasized is-highlighted')
		this.$(`.equation-viewer [data-id=${id}]`).addClass('text-link-emphasized')
	},

	highlightEquationReference: function(e) {
		let target = this.$(e.target)
		this._highlightReference(target, target.data('id') + '-ref')
	},

	highlightReverseEquationReference: function(e) {
		let target = this.$(e.target)
		this._highlightReference(target, target.data('id').substring(0,1))
	},

	removeEquationReferenceHighlight: function() {
		this.$('.equation-viewer .reference').removeClass('text-link-emphasized is-highlighted')
	}
})

export default TextLinkBadgesView
